import React, { useCallback } from "react";
import PropTypes from "prop-types";
import EntitiesSelector, { commonPropTypes } from "./entities-selector";

const query = `
query ProductionTypes($customerId: ID, $offset: Int, $limit: Int) {
  productionTypes(customerId: $customerId, offset: $offset, limit: $limit) {
    items {
      id
      name
      description
    }
    total
  }
}
`;

const ProductionTypeSelectMultiple = ({
  className,
  id = "allowedProductionTypes",
  name = "allowedProductionTypes",
  isInsideForm,
  ...props
}) => {
  const handleDataFromResponse = useCallback(data => data.productionTypes, []);
  const handleGetValue = useCallback(element => element.id, []);
  const handleGetLabel = useCallback(element => element.description, []);

  return (
    <EntitiesSelector
      isInsideForm={isInsideForm}
      className={className}
      multiple
      id={id}
      name={name}
      queryString={query}
      onGetDataFromResponse={handleDataFromResponse}
      onGetValue={handleGetValue}
      onGetLabel={handleGetLabel}
      {...props}
    />
  );
};

ProductionTypeSelectMultiple.propTypes = {
  ...commonPropTypes,
  /**
   * Valor del selector
   */
  value: PropTypes.array,
};

export default ProductionTypeSelectMultiple;
